import React from "react";
import { Create } from "react-admin";
import { MagazineTemplateForm } from "./MagazineTemplateForm";
export const MagazineTemplateCreate = (props) => (
    <Create title="Gerar revista" {...props}>
        <MagazineTemplateForm {...props}/>
    </Create>
);
